/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig"; // Asegúrate de tener tu configuración de axios
import ModalBusquedaAuxiliar from "./components/ModalBusquedaAuxiliar"; // Componente para buscar auxiliares en modal
import { useNavigate, useParams } from 'react-router-dom';
import { formatMoney, formatDate } from "../utils/utils";
import {
    formatAuxiliarSearchLabel,
    getNoEnviarPacienteStatus,
} from "../utils/noEnviarPaciente";

function IngresoReemplazos() {
    const { id_solicitud } = useParams();
    const navigate = useNavigate();

    const [auxiliaresReemplazo, setauxiliaresReemplazo] = useState([]);
    const [pacienteInfo, setPacienteInfo] = useState([]);
    const [auxiliarInfo, setAuxiliarInfo] = useState([]);
    const [auxiliarSelectedInfo, setAuxiliarSelectedInfo] = useState([]);
    const [auxiliares, setAuxiliares] = useState([]);
    const [solicitud, setSolicitud] = useState([]);
    const [reemplazos, setReemplazos] = useState([]);
    const [datosReemplazo, setDatosReemplazo] = useState({
        auxiliarID: 0,
        auxiliarNombre: '',
        fechaInicio: '',
        fechaFin: ''
    });

    const [isAuxiliarModalOpen, setIsAuxiliarModalOpen] = useState(false);

    useEffect(() => {
        async function fetchData() {
            gdAlertify.showLoader()
            try {
                // Aquí se hacen las peticiones para obtener las categorías y los turnos
                const solicitud = await axiosInstance.get("/reemplazos/solicitud/ver/" + id_solicitud);
                let solicitudInfo = solicitud.data.data;
                setSolicitud(solicitudInfo);
                setPacienteInfo(solicitudInfo.paciente);
                setAuxiliarInfo(solicitudInfo.auxiliar);
                setDatosCondiciones({
                    valorTurno: solicitudInfo.valorTurno,
                    valorColacion: solicitudInfo.valorColacion,
                    valorMovilizacion: solicitudInfo.valorMovilizacion,
                    valorOtro: solicitudInfo.valorOtro,
                    fechaInicio: solicitudInfo.fechaInicio,
                    fechaFin: solicitudInfo.fechaFin,
                    turnoID: solicitudInfo.turnoID
                })
                gdAlertify.hideLoader()
            } catch (error) {
                gdAlertify.hideLoader()
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, []);


    const handleEliminarReemplazo = (index) => {
        setReemplazos(reemplazos.filter((_, i) => i !== index));
    };

    const [datosCondiciones, setDatosCondiciones] = useState({
        valorTurno: 0,
        valorColacion: 0,
        valorMovilizacion: 0,
        valorOtro: 0,
        fechaInicio: '',
        fechaFin: '',
        turnoID: 0
    });

    const handleSeleccionAuxiliar = (auxiliar) => {
        if (getNoEnviarPacienteStatus(auxiliar).active) {
            gdAlertify.notiError('No se puede seleccionar: NO ENVIAR A ESTE DOMICILIO.');
            return;
        }

        setAuxiliarSelectedInfo(auxiliar); // Guardamos los detalles completos en un estado independiente
    };

    const handleChangeCondiciones = (e) => {
        const { name, value } = e.target;
        setDatosCondiciones({ ...datosCondiciones, [name]: value });
    };

    const handleChangeDatosReemplazos = (e) => {
        const { name, value } = e.target;
        setDatosReemplazo({ ...datosReemplazo, [name]: value });
    };

    const handleAgregarReemplazo = () => {
        // Validar si falta alguna de las fechas
        if (datosReemplazo.fechaInicio === '' || datosReemplazo.fechaFin === '') {
            gdAlertify.notiError('Faltan fechas del reemplazo.');
            return false;
        }

        // Validar que la fecha de fin sea mayor que la de inicio
        const fechaInicio = new Date(datosReemplazo.fechaInicio);
        fechaInicio.setHours(0, 0, 0, 0);
        const fechaFin = new Date(datosReemplazo.fechaFin);
        fechaFin.setHours(0, 0, 0, 0);

        if (fechaFin < fechaInicio) {
            gdAlertify.notiError('La fecha de fin debe ser mayor a la fecha de inicio.');
            return false;
        }

        let inicioSolicitud = new Date(solicitud.fechaInicio);
        inicioSolicitud.setHours(0, 0, 0, 0);
        let finSolicitud = new Date(solicitud.fechaFin);
        finSolicitud.setHours(0, 0, 0, 0);

        if (fechaInicio < inicioSolicitud) {
            gdAlertify.notiError('La fecha de inicio reemplazo debe ser mayor a la fecha de inicio de la solicitud.');
            return false;
        }

        if (fechaFin > finSolicitud) {
            gdAlertify.notiError('La fecha de fin reemplazo debe ser menor a la fecha de fin de la solicitud.');
            return false;
        }
        // Validar que las fechas no sean fuera del rango de fechas límites de los reemplazos existentes
        if (reemplazos.length > 0) {

            // Validar que las fechas no se crucen con reemplazos existentes
            for (let i = 0; i < reemplazos.length; i++) {
                const reemplazoExistente = reemplazos[i];
                const inicioExistente = new Date(reemplazoExistente.fechaInicio);
                inicioExistente.setHours(0, 0, 0, 0);
                const finExistente = new Date(reemplazoExistente.fechaFin);
                finExistente.setHours(0, 0, 0, 0);

                if (
                    (fechaInicio >= inicioExistente && fechaInicio <= finExistente) || // Fecha inicio del nuevo reemplazo cruza con uno existente
                    (fechaFin >= inicioExistente && fechaFin <= finExistente) ||     // Fecha fin del nuevo reemplazo cruza con uno existente
                    (fechaInicio <= inicioExistente && fechaFin >= finExistente)     // Reemplazo existente está dentro del nuevo rango
                ) {
                    gdAlertify.notiError('Las fechas del reemplazo se cruzan con otro reemplazo existente.');
                    return false;
                }
            }
        }

        // Crear el objeto del reemplazo
        let reemplazo = {
            auxiliarID: auxiliarSelectedInfo.id,
            auxiliarNombre: auxiliarSelectedInfo.nombre
                ? `${auxiliarSelectedInfo.nombre} ${auxiliarSelectedInfo.apellidoPaterno} ${auxiliarSelectedInfo.apellidoMaterno}`
                : '',
            fechaInicio: datosReemplazo.fechaInicio,
            fechaFin: datosReemplazo.fechaFin,
            no_enviar_activo: getNoEnviarPacienteStatus(auxiliarSelectedInfo).active ? 1 : 0,
            no_enviar_observacion: getNoEnviarPacienteStatus(auxiliarSelectedInfo).observation || "",
        };

        // Agregar el nuevo reemplazo al estado
        setReemplazos((reemplazos) => [
            ...reemplazos, // Copiar los reemplazos previos
            reemplazo,     // Agregar el nuevo reemplazo
        ]);
    };

    const handleSubmit = async (e) => {
        if (reemplazos.length < 1) {
            gdAlertify.notiError('Debe agregar un auxiliar para el reemplazo');
            return false;
        }

        e.preventDefault();
        let solicitudEnvio = solicitud;
        gdAlertify.confirm({
            title: 'Confirmar reemplazo',
            message: '¿Desea confirmar estos reemplazos?',
            onConfirm: async () => {
                gdAlertify.showLoader()
                solicitudEnvio.reemplazos = reemplazos;
                try {
                    const response = await axiosInstance.post("/auxiliar/reemplazo/crear", {
                        solicitudEnvio,
                    });

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        navigate('/solicitudes-reemplazos');
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                    gdAlertify.hideLoader()
                } catch (error) {
                    gdAlertify.hideLoader()
                    console.error(error);
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h1 className="mb-4">Ingreso de Solicitud</h1>
                    {/* Datos del Turno a Reemplazar */}
                    <div className="border p-4 mb-4">
                        <h5 className="mb-3">Información Solicitud</h5>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Nombre del Paciente</label>
                                <p id="nombrePaciente" className="form-control-plaintext">{solicitud.paciente ? `${solicitud.paciente.nombres} ${solicitud.paciente.apellidoPaterno} ${solicitud.paciente.apellidoMaterno}` : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Dirección</label>
                                <p id="direccion" className="form-control-plaintext">{solicitud.paciente ? solicitud.paciente.direccion : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Comuna</label>
                                <p id="comuna" className="form-control-plaintext">{solicitud.paciente ? solicitud.paciente.desc_comuna : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Turno Asignado</label>
                                <p id="turnoAsignado" className="form-control-plaintext">{solicitud.paciente ? solicitud.paciente.des_turno : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Hora Inicio</label>
                                <p id="turnoAsignado" className="form-control-plaintext">{solicitud.paciente ? solicitud.paciente.horaInicio : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Hora Fin</label>
                                <p id="turnoAsignado" className="form-control-plaintext">{solicitud.paciente ? solicitud.paciente.horaFin : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Fecha Inicio</label>
                                <p id="turnoAsignado" className="form-control-plaintext">{solicitud.fechaInicio ? formatDate(solicitud.fechaInicio) : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Fecha Fin</label>
                                <p id="turnoAsignado" className="form-control-plaintext">{solicitud.fechaFin ? formatDate(solicitud.fechaFin) : ''}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Auxiliar</label>
                                <p id="nombrePaciente" className="form-control-plaintext">{solicitud.auxiliar ? `${solicitud.auxiliar.nombre} ${solicitud.auxiliar.apellidoPaterno} ${solicitud.auxiliar.apellidoMaterno}` : ''}</p>
                            </div>
                        </div>
                    </div>

                    {/* Ingreso de Reemplazo */}
                    <div className="border p-4 mb-4">
                        <h5 className="mb-3">Fechas del Reemplazo</h5>
                        <div className="row g-3">
                            <div className="col-md-12">
                                <div className="mb-3 col-md-12">
                                    <button className="btn btn-primary" onClick={() => setIsAuxiliarModalOpen(true)}>
                                        Buscar Auxiliar
                                    </button>
                                    <ModalBusquedaAuxiliar
                                        isOpen={isAuxiliarModalOpen}
                                        onClose={() => setIsAuxiliarModalOpen(false)}
                                        onSelect={handleSeleccionAuxiliar}
                                        pacienteAuxiliares={solicitud.paciente?.auxiliares || []}
                                        pacienteID={solicitud.pacienteID || solicitud.paciente?.id}
                                        pacienteNombre={solicitud.paciente ? `${solicitud.paciente.nombres} ${solicitud.paciente.apellidoPaterno || ''}`.trim() : ""}
                                    />
                                </div>
                                <label className="form-label fw-bold">Auxiliar Seleccionado</label>
                                <div id="nombrePaciente" className="form-control-plaintext">
                                    {auxiliarSelectedInfo.nombre ? (
                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            <span>
                                                {formatAuxiliarSearchLabel(auxiliarSelectedInfo, {
                                                    includeRut: false,
                                                    includeNoEnviarSuffix: false,
                                                })}
                                            </span>
                                            {getNoEnviarPacienteStatus(auxiliarSelectedInfo).active && (
                                                <span className="badge bg-warning text-dark">NO ENVIAR A ESTE DOMICILIO</span>
                                            )}
                                        </div>
                                    ) : ''}
                                </div>
                                {getNoEnviarPacienteStatus(auxiliarSelectedInfo).active && (
                                    <div className="alert alert-warning py-2">
                                        <i className="bi bi-exclamation-triangle me-1"></i>
                                        Este auxiliar esta marcado como NO ENVIAR A ESTE DOMICILIO para este paciente.
                                        {getNoEnviarPacienteStatus(auxiliarSelectedInfo).observation
                                            ? ` Obs: ${getNoEnviarPacienteStatus(auxiliarSelectedInfo).observation}`
                                            : ""}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="fechaInicio" className="form-label">
                                    Inicio de Reemplazo
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="fechaInicio"
                                    value={datosReemplazo.fechaInicio}
                                    onChange={handleChangeDatosReemplazos}
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="fechaFin" className="form-label">
                                    Fin de Reemplazo
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="fechaFin"
                                    value={datosReemplazo.fechaFin}
                                    onChange={handleChangeDatosReemplazos}
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-center mt-3">
                                <button className="btn btn-primary" onClick={handleAgregarReemplazo}>Agregar Auxiliar</button>
                            </div>
                            {/* <div className="col-md-6">
                                <BuscarAuxiliar
                                    onSelect={() => { }}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="motivoReemplazo" className="form-label">
                                    Motivos del Reemplazo
                                </label>
                                <textarea
                                    id="motivoReemplazo"
                                    className="form-control"
                                    rows="2"
                                ></textarea>
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                                <button className="btn btn-primary">Agregar Reemplazo</button>
                            </div> */}
                        </div>
                    </div>
                    <div className="border p-4 mb-4">
                        <h2>Resumen</h2>
                        {reemplazos.length > 0 ? (
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Nombre Auxiliar</th>
                                        <th>Fecha Inicio</th>
                                        <th>Fecha Fin</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reemplazos.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    <span>{item.auxiliarNombre}</span>
                                                    {item.no_enviar_activo == 1 && (
                                                        <span className="badge bg-warning text-dark">NO ENVIAR A ESTE DOMICILIO</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>{item.fechaInicio}</td>
                                            <td>{item.fechaFin}</td>
                                            <td>
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={() => handleEliminarReemplazo(index)}
                                                >
                                                    Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No hay auxiliares agregados aún</p>
                        )}
                    </div>
                    {/* Condiciones del Reemplazo */}
                    <div className="border p-4 mb-4">
                        <h5 className="mb-3">Condiciones del Reemplazo</h5>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label htmlFor="valorTurno" className="form-label">
                                    Valor del Turno
                                </label>
                                <input
                                    type="number"
                                    id="valorTurno"
                                    className="form-control"
                                    value={formatMoney(datosCondiciones.valorTurno)}
                                    onChange={handleChangeCondiciones}
                                    readOnly
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="colacion" className="form-label">
                                    Asignación de Colación
                                </label>
                                <input
                                    type="number"
                                    id="valorColacion"
                                    className="form-control"
                                    value={formatMoney(datosCondiciones.valorColacion)}
                                    onChange={handleChangeCondiciones}
                                    readOnly
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="movilizacion" className="form-label">
                                    Asignación de Movilización
                                </label>
                                <input
                                    type="number"
                                    id="valorMovilizacion"
                                    className="form-control"
                                    value={formatMoney(datosCondiciones.valorMovilizacion)}
                                    onChange={handleChangeCondiciones}
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="text-center mt-3">
                            <button className="btn btn-success" onClick={handleSubmit}>Ingresar Solicitud</button>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default IngresoReemplazos;
